import {
  SET_BRANCH_DELIVERY_CHARGE,
  RESET_TO_INITIAL_STATE,
} from "../actions/actionTypes";

const initialState = {
  loading: false,
  branch: null,
  bdc: null,
  isPickup: false,
  nextPage: null,
};

function convertToJS(data) {
  let d = data.replace(new RegExp("'", "g"), '"');
  d = d.replace(new RegExp("None", "g"), "null");
  d = d.replace(new RegExp("False", "g"), "false");
  d = d.replace(new RegExp("True", "g"), "true");
  return JSON.parse(d);
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case "LOAD_BRANCH_JSON":
      return { ...convertToJS(payload) };

    case "CLEAR_BRANCH":
      return {
        loading: false,
        branch: null,
        bdc: null,
        isPickup: false,
        nextPage: null,
        prevState: null,
      };
    case SET_BRANCH_DELIVERY_CHARGE:
      return { ...state, ...payload };
    case "SET_BRANCH_LOADING_FALSE":
      return { ...state, loading: false };
    case "STOP_LOADING":
      return { ...state, loading: false };
    case RESET_TO_INITIAL_STATE:
      return { ...initialState };
    case "SET_NEXT_PAGE":
      return { ...state, nextPage: payload };
    case "SET_PREV_STATE":
      return { ...state, prevState: payload };
    case "UPDATE_BRANCH":
      return {
        ...state,
        isPickup: false,
        branch: payload?.branch_delivery_charge__branch__id || null,
        bdc: payload?.branch_delivery_charge_id || null,
      };
    case "SET_BRANCH_FROM_SAVED_ADDRESS":
      if (!!payload.addresses[0].branch_delivery_charge__branch__id) {
        let preferredAddress =
          payload.addresses.find((a) => a.is_preferred) || payload.addresses[0];
        if (preferredAddress) {
          return {
            ...state,
            isPickup: false,
            branch: preferredAddress.branch_delivery_charge__branch__id,
            bdc: preferredAddress.branch_delivery_charge_id,
          };
        }
      } else {
        return state;
      }
    default:
      return state;
  }
};
